import Model from "../Model";

class BackSaleType extends Model{

    buildUrl ({ param }) {
        return ['saletype', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BackSaleType;